import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy Clerk path; verification runs on `/signup` in `CustomClerkSignUpForm`. */
export const Route = createFileRoute('/signup/verify-email-address')({
  beforeLoad: () => {
    throw redirect({ to: '/signup', replace: true });
  },
  component: () => null,
});
